import { Stack, Typography } from "@mui/material";
import { colors } from "../utils/colors";

export default function FormTextFieldLabel({
  label,
  labelRight,
  forgotPassword,
  onClickForgotPassword,
  required = false
}) {
  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between"
      >
        <Stack direction="row" >
          <Typography
            className="fs-14 ff-Roboto fw-medium mb-7"
            color={colors.blackMain}
          >
            {label}{" "}
          </Typography>
          {required && <Typography className="text-red-500 !pl-[5px]">*</Typography>}
          {labelRight && <Typography className="!pl-[5px] fs-14 ff-Roboto fw-medium mb-7"> {labelRight}</Typography>}
        </Stack>
        {forgotPassword ? (
          <Typography
            style={{ cursor: "pointer" }}
            mt={2}
            onClick={onClickForgotPassword}
            className="fs-14 ff-Roboto fw-regular mb-7"
            color={"rgb(6, 29, 48, 0.5)"}
          >
            Forgot Password?
          </Typography>
        ) : (
          ""
        )}
      </Stack>
    </>
  );
}
